import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'
import { getUnitLabel, getUnitValue } from 'type/LengthUnit'

type Props = {
  min: number
  max: number
  plus?: boolean
}

export const SizeRange = observer(({ min, max, plus }: Props) => {
  const { unit } = store.profile

  return <Space opposite>
    <Typo size={12} secondary lower>
      {getUnitValue(min, unit)} {getUnitLabel(min, unit)}
    </Typo>
    <Typo size={12} secondary lower>
      {getUnitValue(max, unit)}{plus && '+'} {getUnitLabel(max, unit)}
    </Typo>
  </Space>
})
